import { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Customers from './pages/Customers';
import Workers from './pages/Workers';
import Bookings from './pages/Bookings';
import Services from './pages/Services';
import Categories from './pages/Categories';
import Tickets from './pages/Tickets';
import Payments from './pages/Payments';
import Reviews from './pages/Reviews';
import Branding from './pages/Branding';
import Staff from './pages/Staff';
import ServiceAreas from './pages/ServiceAreas';
import MapView from './pages/MapView';
import Promos from './pages/Promos';
import Announcements from './pages/Announcements';
import Analytics from './pages/Analytics';
import Sidebar from './components/Sidebar';

export default function App() {
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState('dashboard');

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const savedUser = localStorage.getItem('admin_user');
    if (token && savedUser) {
      try { setUser(JSON.parse(savedUser)); } catch (_) {}
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setUser(null);
  };

  if (!user) return <Login onLogin={setUser} />;

  const userRole = user.admin_role || 'super_admin';

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard': return <Dashboard userRole={userRole} />;
      case 'users': return <Users />;
      case 'customers': return <Customers />;
      case 'workers': return <Workers />;
      case 'bookings': return <Bookings />;
      case 'services': return <Services />;
      case 'categories': return <Categories />;
      case 'payments': return <Payments />;
      case 'tickets': return <Tickets />;
      case 'reviews': return <Reviews />;
      case 'branding': return <Branding />;
      case 'staff': return <Staff />;
      case 'service_areas': return <ServiceAreas />;
      case 'map_view': return <MapView />;
      case 'promos': return <Promos />;
      case 'announcements': return <Announcements />;
      case 'analytics': return <Analytics />;
      default: return <Dashboard userRole={userRole} />;
    }
  };

  return (
    <div className="layout">
      <Sidebar
        activePage={activePage}
        setActivePage={setActivePage}
        onLogout={handleLogout}
        userRole={userRole}
      />
      <div className="main-content">
        {renderPage()}
      </div>
    </div>
  );
}
